<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { fade, fly } from "svelte/transition";
import uiStore from "../../utils/UIStore";
import { renderMarkdown } from "../../utils/markdownParser";

let privacyPolicy = "";

//load ui texts from ui Store
uiStore.textStore.subscribe((store) => {
	if (store.texts != null) {
		privacyPolicy = store.texts.privacypolicy;
	}
});

let uiTexts;
uiStore.textStore.subscribe((store) => {
	uiTexts = store.texts;
});
</script>

<svelte:head>
    <title>{uiTexts.pageTitles.privacy}</title>
</svelte:head>

<main class="main-text-container" transition:fade>
    <div class="terms_container" in:fly={{ y: -20, duration: 500, delay: 500 }}>
        <h4>{uiTexts.privacy.pageTitle}</h4>
        <div class="text_box">
            {@html renderMarkdown(privacyPolicy)}
        </div>
    </div>
</main>

<style>
    main {
        text-align: left;
        padding-left: 20vw;
        padding-right: 20vw;
        padding-top: 90px;
        margin: 0 auto;
        width: 100%;
        padding-bottom: 120px;
        display: grid;
        background-size: 90%;
        background-repeat: no-repeat;
        background-position: center;
        width: 80vw;
    max-width: 1000px;
    }

    h4 {
        font-weight: 700;
        font-size: 2rem;
        margin-top: 25px;
        margin-bottom: 30px;
        line-height: 54px;
        text-align: left;
        white-space: break-spaces;
        width: 100%;
    }



    @media screen and (max-width: 1100px) {
        h4 {
            width: 80vw;
        }
    }

    @media screen and (max-width: 950px) {
        h4 {
            font-size: 1.2rem;
            text-align: left;
        }
    }

    @media screen and (max-width: 500px) {
        .text_box {
            width: 95vw;
        }
        h4 {
            font-size: 1.2rem;
            line-height: 1.2rem;
        }
    }
</style>
